import { Button, Form, Row, Col } from 'react-bootstrap'
import '../css/client/editclient.css'
import { MdClose, MdSave, MdEdit } from 'react-icons/md'
import { useContext, useEffect, useState } from 'react'
import api from '../../api'
import { auth } from "../../firebase"
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';
import Swal from 'sweetalert2'
import { Dimcontext } from '../../context/pagecontext'
import { ToastContainer } from 'react-toastify'
import { Datacontext } from '../../context/dataContext'
import { useNavigate } from "react-router-dom";

export const Editclient = ({ set_edit, id, showToast }) => {
    const navigate = useNavigate()
    const { setDim } = useContext(Dimcontext)
    const { fetchClients, clients } = useContext(Datacontext)
    
    // Combined initial state (includes nick_name, role, and alt_mobile)
    const [editclient, set_editClient] = useState({
        cid: "", name: "", nick_name: "", role: "client", gender: "", mobile: "", alt_mobile: "", address: "", city: "", state: "", pincode: ""
    });
    
    const [hasMobile, setHasMobile] = useState('yes')

    useEffect(() => {
        const editoneClient = () => {
            const data = clients.find(item => item.id === id);
            if (data) {
                // Merge data, defaulting role to 'client' if missing on older records
                set_editClient({ ...data, role: data.role || 'client' });
                // Automatically set to 'yes' if they already have a mobile number saved, else 'no'
                setHasMobile((data.mobile && data.mobile.trim() !== "") ? 'yes' : 'no');
            }
        };
        editoneClient()
    }, [id, clients])

    const handlechangepin = (e) => {
        set_editClient({
            ...editclient,
            pincode: e.target.value.replace(/\D/g, "")
        })
    }

    const handeleeditandclose = async (e) => {
        e.preventDefault()
        
        if (!/^[A-Za-z ]{2,50}$/.test(editclient.name)) return showToast("INVALID NAME FORMAT");
        
        // Updated validation for conditional mobile numbers and duplicate check
        if (hasMobile === 'yes') {
            if (!editclient.mobile || String(editclient.mobile).length !== 10) return showToast("MOBILE MUST BE 10 DIGITS");
            
            if (editclient.alt_mobile) {
                if (String(editclient.alt_mobile).length !== 10) {
                    return showToast("ALTERNATE MOBILE MUST BE 10 DIGITS");
                }
                if (editclient.mobile === editclient.alt_mobile) {
                    return showToast("MOBILE AND ALTERNATE MOBILE MUST BE DIFFERENT");
                }
            }
        }

        // Simple manual validation for location
        if (!editclient.city || !editclient.state) {
            return showToast("PLEASE ENTER DISTRICT AND STATE");
        }

        // Clean payload: If user selected "No", ensure mobile fields are empty before saving
        const payload = { ...editclient };
        if (hasMobile === 'no') {
            payload.mobile = "";
            payload.alt_mobile = "";
        }

        try {
            const up = await api.patch(`/update/${id}`, payload)
             fetchClients()
            Swal.fire({
                title: "Updated!",
                text: up.data.message,
                icon: "success",
                confirmButtonColor: "#00C896"
            });
            handleeditclose()
        } catch (err) {
             console.error(err); 
            if (err.response && err.response.status === 401) {
                showToast("Session expired. Attempting to refresh...");
                try {
                    const freshToken = await auth.currentUser.getIdToken(true);
                    sessionStorage.setItem("token", freshToken);
                } catch (refreshErr) {
                    showToast("Refresh failed. Logging out.");
                    navigate("/")            
                }
            } else {
                showToast("Something went wrong. Please try again.");
            }
        }
    }

    const handleeditclose = () => {
        set_edit(false)
        setDim(false)
    }

    return (
        <div className="edit-modal-container">
            <ToastContainer/>
            <div className='edit-modal-header'>
                <div className="d-flex align-items-center gap-2">
                    <div className="edit-brand-icon"><MdEdit /></div>
                    <h3 className='m-0'>Edit Profile Information</h3>
                </div>
                <button onClick={handleeditclose} className='modal-close-btn'><MdClose /></button>
            </div>

            <SimpleBar style={{ maxHeight: 'calc(90vh - 130px)' }}>
                <Form className="edit-modal-body" onSubmit={handeleeditandclose}>
                    <Row className="g-3 p-4">
                        {/* Row 1 */}
                        <Col md={4}>
                            <Form.Label className="edit-label">Client ID</Form.Label>
                            <Form.Control className="read-only-fld" value={editclient.cid || ''} readOnly />
                        </Col>
                        <Col md={4}>
                            <Form.Label className="edit-label">Full Name</Form.Label>
                            <Form.Control 
                                required
                                value={editclient.name || ''} 
                                onChange={(e) => set_editClient({ ...editclient, name: e.target.value })} 
                            />
                        </Col>
                        <Col md={4}>
                            <Form.Label className="edit-label">Nick Name</Form.Label>
                            <Form.Control 
                                value={editclient.nick_name || ''} 
                                placeholder="Enter nickname (optional)"
                                onChange={(e) => set_editClient({ ...editclient, nick_name: e.target.value })} 
                            />
                        </Col>

                        {/* Row 2 */}
                        <Col md={4}>
                            <Form.Label className="edit-label">Client / Broker</Form.Label>
                            <div className="gender-radio-group">
                                <Form.Check inline type="radio" label="Client" name="role" value="client" checked={editclient.role === 'client'} onChange={(e) => set_editClient({ ...editclient, role: e.target.value })} />
                                <Form.Check inline type="radio" label="Broker" name="role" value="broker" checked={editclient.role === 'broker'} onChange={(e) => set_editClient({ ...editclient, role: e.target.value })} />
                            </div>
                        </Col>
                        <Col md={4}>
                            <Form.Label className="edit-label">Gender</Form.Label>
                            <div className="gender-radio-group">
                                <Form.Check inline type="radio" label="Male" name="gender" value="male" checked={editclient.gender === 'male'} onChange={(e) => set_editClient({ ...editclient, gender: e.target.value })} />
                                <Form.Check inline type="radio" label="Female" name="gender" value="female" checked={editclient.gender === 'female'} onChange={(e) => set_editClient({ ...editclient, gender: e.target.value })} />
                            </div>
                        </Col>
                        <Col md={4}>
                            <Form.Label className="edit-label">Has Mobile Number?</Form.Label>
                            <div className="gender-radio-group">
                                <Form.Check inline type="radio" label="Yes" name="hasMobile" value="yes" checked={hasMobile === 'yes'} onChange={(e) => setHasMobile(e.target.value)} />
                                <Form.Check inline type="radio" label="No" name="hasMobile" value="no" checked={hasMobile === 'no'} onChange={(e) => setHasMobile(e.target.value)} />
                            </div>
                        </Col>

                        {/* Conditional Row 3 */}
                        {hasMobile === 'yes' && (
                            <>
                                <Col md={6}>
                                    <Form.Label className="edit-label">Mobile Number</Form.Label>
                                    <Form.Control 
                                        type="text" maxLength={10} required
                                        value={editclient.mobile || ''} 
                                        pattern="[0-9]{10}"
                                        onChange={(e) => set_editClient({ ...editclient, mobile: e.target.value.replace(/\D/g, "") })} 
                                    />
                                </Col>

                                <Col md={6}>
                                    <Form.Label className="edit-label">Alternate Mobile Number</Form.Label>
                                    <Form.Control 
                                        type="text" maxLength={10} 
                                        value={editclient.alt_mobile || ''} 
                                        pattern="[0-9]{10}"
                                        onChange={(e) => set_editClient({ ...editclient, alt_mobile: e.target.value.replace(/\D/g, "") })} 
                                    />
                                </Col>
                            </>
                        )}

                        {/* Row 4 */}
                        <Col xs={12}>
                            <Form.Label className="edit-label">Residential Address</Form.Label>
                            <Form.Control 
                                as="textarea" rows={2} required
                                value={editclient.address || ''} 
                                onChange={(e) => set_editClient({ ...editclient, address: e.target.value })} 
                            />
                        </Col>

                        {/* Row 5 - Location Fields */}
                        <Col md={4}>
                            <Form.Label className="edit-label">Pincode</Form.Label>
                            <div className="d-flex gap-2">
                                <Form.Control
                                    maxLength={6}
                                    value={editclient.pincode || ''}
                                    pattern="[0-9]{6}"
                                    onChange={handlechangepin}
                                    required
                                />
                            </div>
                        </Col>

                        <Col md={4}>
                            <Form.Label className="edit-label">District</Form.Label>
                            <Form.Control
                                className="custom-input"
                                value={editclient.city || ''}
                                required
                                placeholder="Enter district"
                                onChange={(e) =>
                                    set_editClient({
                                        ...editclient,
                                        city: e.target.value
                                    })
                                }
                            />
                        </Col>

                        <Col md={4}>
                            <Form.Label className="edit-label">State</Form.Label>
                            <Form.Control
                                className="custom-input"
                                value={editclient.state || ''}
                                required
                                placeholder="Enter state"
                                onChange={(e) =>
                                    set_editClient({
                                        ...editclient,
                                        state: e.target.value
                                    })
                                }
                            />
                        </Col>
                    </Row>
                    
                    <div className="edit-modal-footer p-2">
                        <Button type="submit" className="btn-update-client">
                            <MdSave className="me-2" /> Save Changes
                        </Button>
                    </div>
                </Form>
            </SimpleBar>
        </div>
    )
}